<template>
  <!-- O gradiente azul do wrapper saiu: quem dá o lugar agora é o FishScene do ClanPage (D8). -->
  <ClanPage />
</template>

<script>
import ClanPage from '@/shared/clan/ClanPage.vue';

export default {
  name: 'ClanPageWrapper',
  components: {
    ClanPage
  }
}
</script>
